import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Checkbox = (props) => {
	return (
		<div className={cx('Checkbox', 'form-check', {'form-check-inline': props.inline})}>
			<input className="form-check-input"
				id={props.id}
				name={props.name}
				type='checkbox'
				checked={props.value === true ? true : false}
				onChange={(e) => props.onChange(e.currentTarget.checked)}
			/>
			<label className="form-check-label" htmlFor={props.id}>
					{props.label}
			</label>
		</div>
	);
};

Checkbox.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.any.isRequired,
	onChange: PropTypes.func.isRequired,
	name: PropTypes.string,
	inline: PropTypes.bool
};

export default Checkbox;
